import images from "../afbeeldingen/images";

const ProjectTranslations = {
  title: "Translations",
  subtitle: "Context",
  year: "Stage",
  description:
    "In een vorige applicatie, genaamd fenics hebben ze heel veel vertalingen die er zijn. Ook zijn er woorden die nog niet vertaald zijn of nog vertaald moeten worden. Maar in fenics is het wat moeilijker om vertalingen te doen. Daarom heb ik een applicatie gemaakt waar je alle vertalingen kunt zien van de taal die je gekozen hebt. Maar ook heb ik gemaakt dat de vertalingen automatisch gebeuren en dat die ook aan de juiste namespace worden gekoppeld. Maar voordat je een vertaling kunt koppelen aan een namespace, moet je eerst alle namespaces aanmaken. Dat heb ik ook gemaakt.",
  extraContentHTML: `
        <h3>Wat zijn de dingen die nodig zijn voor een vertaling</h3>
        De dingen die nodig zijn om een vertaling toe te voegen, zijn:
        <br>
        1. Language: de taal waar de vertaling in gebeurd is
        <br>
        2. Key: het woord, de zin, de paragraaf die gebruikt wordt om te vertalen
        <br>
        3. Application name: de naam van de applicatie waar deze zich in bevindt
        <br>
        4. Value: de vertaalde key
        <br>
        5. Type: het type van de vertaling, bijvoorbeeld ‘Phoenix translations’
        <br>
        6. Language state: de status van de vertaling ‘not verified’ of ‘verified’
        <br>
        7. Namespace: de namespace van de pagina waar je op bent, bijvoorbeeld ‘/phoenix/home’
        <br>
        <h3>Namespaces automatisch aanmaken</h3>
        Ik heb gemaakt dat als je op een pagina komt, dat die dan automatisch het pad van de URL pakt en dat die dan kijkt of die bestaan in de database of niet. Als die niet bestaat, wordt die toegevoegd.
        <h3>Vertalingen automatisch aanmaken voor de namespace van de pagina</h3>
        Als de namespace bestaat voor de pagina waar je op dat moment bent, dan wordt de vertaling automatisch toegevoegd
        voor die pagina. Indien je een vertaling verwijdert en je gaat terug naar die pagina, dan wordt de
        vertaling terug opnieuw aangemaakt voor de namespace die voor de pagina is.
        <h3>Hoe worden de vertalingen gedaan?</h3>
        De vertalingen gebeuren door middel van i18Next. I18Next helpt ontwikkelaars om teksten, talen en vertalingen te
        beheren in hun applicaties. In de code zetten we savemissing (een configuratieoptie) op ‘true’.
        Vervolgens, als we dat op ‘true’ hebben gezet, kunnen we t (van translation) importeren van i18Next.
        Deze t kunnen wij dan rond een woord, zin, paragraaf, enz. zetten en zo weet i18Next dat het een ‘missing key’ is.
        Als savemissing getriggerd wordt, dan gaat die automatisch naar de backendmodule van i18Next.
        Maar ik heb dat vervangen door een custom backend, zodat ik daar in mijn API-calls kan doen om de vertalingen te
        laten toevoegen voor de bepaalde namespace.
        <br>
        Zo wordt de t tag gebruikt in de code
        <img src="${images.vertalingtag}"  style="width:100%; height:auto;" />
        <h3>Translations management page</h3>
        Als je op de applicatie translations klikt, kom je onmiddellijk op de translations management-pagina.
        Op deze pagina moet je eerst kiezen welke taal je de vertalingen voor wilt zien.
        <img src="${images.dropdown}"  style="width:100%; height:auto;" />
        <br>
        Als je bijvoorbeeld de taal Spaans kiest, dan krijg je alle vertalingen die gebeurd zijn in het Spaans.
        <br>
        <img src="${images.filteredtranslations}"  style="width:100%; height:auto;" />
        <br>
        Vervolgens kan je dubbelklikken op een woord en kan je dat aanpassen.
        Maar zoals je ziet kan ik alleen maar de value aanpassen.
        En dat klopt, want in de permissies staat dat als je de rol maintainer hebt, dat je dan alleen maar de value mag aanpassen.
        <img src="${images.permissie1}"  style="width:100%; height:auto;" />
        <br>
        Maar nu ik de adminrol heb, kan ik de value en de language state aanpassen.
        <img src="${images.permissie2}"  style="width:100%; height:auto;" />
        <h3>Type table page</h3>
        Als je een type wilt toevoegen, dan kan je dat doen op de type table page.
        Op deze pagina kan je ook een type aanpassen of deleten.
        <br>
        <img src="${images.typetable}"  style="width:100%; height:auto;" />
        <br>
        Als je een type wil toevoegen, klik je op de add-knop en dan verschijnt er een veld waar je het type in kunt geven.
        Als je op enter klikt of je klikt buiten het veld, dan wordt het type toegevoegd en wordt het getoond op het scherm.
        <br>
        <img src="${images.toevoegentype}"  style="width:100%; height:auto;" />
        <br>
        Als je een type wilt aanpassen, dan kan je een type selecteren en vervolgens op de edit-knop klikken.
        Je kan ook dubbelklikken op een type en zo kan je het ook editen. Hetzelfde als met het toevoegen,
        ook hier kan je erbuiten klikken of op enter klikken om het type te saven.
        <br>
        <img src="${images.aanpassentype}"  style="width:100%; height:auto;" />
        <br>
        Als je een type wilt deleten, dan kan je het type selecteren dat je wilt deleten en vervolgens op de delete-knop
        klikken. Vervolgens komt er een pop-up om te vragen of je het zeker wilt deleten.
        Als je op delete klikt, wordt het type verwijderd. Als je op close klikt, gebeurt er niks.
        <br>
        <img src="${images.deletentype}"  style="width:100%; height:auto;" />
        <br>
        De namespace en language state table zijn precies hetzelfde als de type table.
        <h3>Key table page</h3>
        Op de key page zie je alle keys die er zijn in het Engels. Hier kan je enkel een key verwijderen.
        Als je bijvoorbeeld de key settings wilt verwijderen, dan verwijder je de key voor ineens alle talen die er zijn.
        Als de key nog bestaat in de code met een t()-tag, dan wordt die weer automatisch toegevoegd.
        <br>
        <img src="${images.keytable}"  style="width:100%; height:auto;" />
        <br>
        <h3>Translations offcanvas</h3>
        Er is ook een offcanvas op elke pagina voor de vertalingen die er zijn op een bepaalde pagina.
        Bijvoorbeeld op de key page is er maar 1 key: ‘key table’.
        Deze kan je in de offcanvas aanpassen en dan wordt het onmiddellijk aangepast in de tabel
        <br>
        <img src="${images.translationsoffcanvas}"  style="width:100%; height:auto;" />
        <br>
        Het aanpassen gebeurt op dezelfde manier als voor alle andere tabellen.
        <br>
        <img src="${images.translationsoffcanvasaanpassen}"  style="width:100%; height:auto;" />
        <br>
        Als de aanpassing gebeurd is in de offcanvas, dan wordt deze onmiddellijk getoond op de pagina zoals je ziet op de foto.
        <br>
        <img src="${images.aangepastrecord}"  style="width:100%; height:auto;" />
        <br>
        <h3>Een andere taal kiezen</h3>
        Als je een andere taal wilt hebben dan Engels, dan kan je gewoon recht boven op een vlag klikken.Als je op de vlag klikt, opent een vak met alle talen die er zijn.Als je op de vlag klikt voor de taal die je wilt hebben, dan wordt heel het scherm aangepast naar de vertalingenvan de taal die je gekozen hebt. De woorden veranderen alleen als die ook vertaald zijn.
        <br>
        <img src="${images.dropdowntaal}"  style="width:25%; height:25%; display: block; margin: 0 auto"; />
        <br>
        Zoals je ziet heb ik de taal Spaans gekozen en zijn alle vertalingen omgezet naar het Spaans.
        <br>
        <img src="${images.aangepastetaal}"  style="width:100%; height:auto;" />
        <br>
        Niet alleen het scherm is aangepast, maar ook de offcanvas is aangepast naar de taal die je hebt gekozen.
        Ook deze kan je aanpassen en het wordt ook onmiddellijk getoond op het scherm.
        <br>
        <img src="${images.aangepasteoffcanvastaal}"  style="width:100%; height:auto;" />
        <br>
        <h3>Besluit</h3>
        Tijdens dit project heb ik geleerd hoe ik met i18next en een translation API kan werken, maar vooral hoe ik complexe vertaalprocessen efficiënt kan automatiseren.
        Een hoogtepunt was het bouwen van een offcanvas-component, waarmee ik vertalingen direct kon aanpassen en de resultaten live kon bekijken. Dit gaf me een gevoel van controle en inzicht in hoe gebruikers met de applicatie interageren.
        Daarnaast ben ik persoonlijk gegroeid in mijn communicatieve vaardigheden. Ik heb geleerd om duidelijk en zelfverzekerd te presenteren tijdens teammeetings en om technische concepten op een begrijpelijke manier uit te leggen aan collega’s zonder technische achtergrond.
      `,
  extraContentJSX: (
    <>
      <h3>Bekijk Documentatie</h3>
      <p>
        Indien de foto's niet duidelijk zijn, kan je de documentatie altijd
        bekijken bij het klikken op deze knop:
      </p>
      <a
        href="../Documentatie_Translations_application.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={`btn mt-2 btn-primary`}
      >
        Bekijk Documentatie
      </a>
    </>
  ),
  image: images.translationsLogo,
};
export default ProjectTranslations;
